const currentUrl = new URL(location);
const requestUrl = `${currentUrl.protocol}//${currentUrl.host + (currentUrl.pathname.startsWith("/local") ? "/local" : "")}/.rest/delivery/website`;

// Fetch page content
export async function getContent(path) {
    return await fetch(requestUrl + path);
}
